<template>
  <div class="d-flex flex-column flex-grow-1 mr-2 mb-2 rounded">
    <div>
      <table
        class="table table-responsive-lg rounded shadow-sm"
        v-background-3
        v-color-1
      >
        <thead class="text-center">
          <tr>
            <th scope="col" class="text-left">Fournisseurs</th>
            <th scope="col">{{ $moment().year() - 3 }}</th>
            <th scope="col">{{ $moment().year() - 2 }}</th>
            <th scope="col">{{ $moment().year() - 1 }}</th>
            <th scope="col">{{ $moment().year() }}</th>
          </tr>
        </thead>
        <tbody class="">
          <tr class="text-center">
            <th class="text-left" scope="row">Nombre de fournisseurs actifs</th>
            <td>{{ statEvalFournisseur(3).nbrFournisseurs }}</td>
            <td>{{ statEvalFournisseur(2).nbrFournisseurs }}</td>
            <td>{{ statEvalFournisseur(1).nbrFournisseurs }}</td>
            <td>{{ statEvalFournisseur(0).nbrFournisseurs }}</td>
          </tr>
          <tr class="text-center">
            <th class="text-left" scope="row">
              Nombre de fournisseurs évalués
            </th>
            <td>{{ statEvalFournisseur(3).nbrFournisseursEvalues }}</td>
            <td>{{ statEvalFournisseur(2).nbrFournisseursEvalues }}</td>
            <td>{{ statEvalFournisseur(1).nbrFournisseursEvalues }}</td>
            <td>{{ statEvalFournisseur(0).nbrFournisseursEvalues }}</td>
          </tr>
          <tr class="text-center">
            <th class="text-left" scope="row">Note moyenne qualité (/4)</th>
            <td>{{ statEvalFournisseur(3).noteMoyenneQualite }}</td>
            <td>{{ statEvalFournisseur(2).noteMoyenneQualite }}</td>
            <td>{{ statEvalFournisseur(1).noteMoyenneQualite }}</td>
            <td>{{ statEvalFournisseur(0).noteMoyenneQualite }}</td>
          </tr>
          <tr class="text-center">
            <th class="text-left" scope="row">Note moyenne coût (/4)</th>
            <td>{{ statEvalFournisseur(3).noteMoyenneCout }}</td>
            <td>{{ statEvalFournisseur(2).noteMoyenneCout }}</td>
            <td>{{ statEvalFournisseur(1).noteMoyenneCout }}</td>
            <td>{{ statEvalFournisseur(0).noteMoyenneCout }}</td>
          </tr>
          <tr class="text-center">
            <th class="text-left" scope="row">Note moyenne délais (/4)</th>
            <td>{{ statEvalFournisseur(3).noteMoyenneDelais }}</td>
            <td>{{ statEvalFournisseur(2).noteMoyenneDelais }}</td>
            <td>{{ statEvalFournisseur(1).noteMoyenneDelais }}</td>
            <td>{{ statEvalFournisseur(0).noteMoyenneDelais }}</td>
          </tr>
          <tr class="text-center">
            <th class="text-left" scope="row">Note moyenne sser (/4)</th>
            <td>{{ statEvalFournisseur(3).noteMoyenneSSER }}</td>
            <td>{{ statEvalFournisseur(2).noteMoyenneSSER }}</td>
            <td>{{ statEvalFournisseur(1).noteMoyenneSSER }}</td>
            <td>{{ statEvalFournisseur(0).noteMoyenneSSER }}</td>
          </tr>
          <tr class="text-center">
            <th class="text-left" scope="row">Note moyenne sûreté (/4)</th>
            <td>{{ statEvalFournisseur(3).noteMoyenneSurete }}</td>
            <td>{{ statEvalFournisseur(2).noteMoyenneSurete }}</td>
            <td>{{ statEvalFournisseur(1).noteMoyenneSurete }}</td>
            <td>{{ statEvalFournisseur(0).noteMoyenneSurete }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapMultiRowFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      loading: false,
      feedback: {},
      tab: 1
    };
  },
  methods: {
    ...mapActions({}),

    statEvalFournisseur(dt) {
      const annee = this.$moment().year() - dt;

      let nbrFournisseurs = this.fournisseurs.filter(
        d =>
          d.etat == 1 &&
          ((d.date_fin == null && d.date_debut == null) ||
            (this.$moment(d.date_debut).year() <= annee &&
              (d.date_fin == null || this.$moment(d.date_fin).year() >= annee)))
      ).length;

      let noteMoyenneQualite = 0;
      let noteMoyenneCout = 0;
      let noteMoyenneDelais = 0;
      let noteMoyenneSSER = 0;
      let noteMoyenneSurete = 0;
      let counter = 0;
      let counter2 = 0;
      let counter3 = 0;
      let counter4 = 0;
      let counter5 = 0;
      let counter6 = 0;

      this.evaluations.forEach(d => {
        if (this.$moment(d.eval_date).year() == this.$moment().year() - dt) {
          noteMoyenneQualite = noteMoyenneQualite + d.eval_1;
          noteMoyenneCout = noteMoyenneCout + d.eval_2;
          noteMoyenneDelais = noteMoyenneDelais + d.eval_3;
          noteMoyenneSSER = noteMoyenneSSER + d.eval_4;
          noteMoyenneSurete = noteMoyenneSurete + (d.eval_5 || 0);
          counter++;

          if (d.eval_1 > 0) counter2++;
          if (d.eval_2 > 0) counter3++;
          if (d.eval_3 > 0) counter4++;
          if (d.eval_4 > 0) counter5++;
          if (d.eval_5 && d.eval_5 > 0) counter6++;
        }
      });

      return {
        nbrFournisseurs: nbrFournisseurs,
        nbrFournisseursEvalues: counter,
        noteMoyenneQualite: counter2
          ? (noteMoyenneQualite / counter2).toFixed(1)
          : "-",
        noteMoyenneCout: counter3
          ? (noteMoyenneCout / counter3).toFixed(1)
          : "-",
        noteMoyenneDelais: counter4
          ? (noteMoyenneDelais / counter4).toFixed(1)
          : "-",
        noteMoyenneSSER: counter5
          ? (noteMoyenneSSER / counter5).toFixed(1)
          : "-",
        noteMoyenneSurete: counter6
          ? (noteMoyenneSurete / counter6).toFixed(1)
          : "-"
      };
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({ havePermission: "user/havePermission" }),
    ...mapGetters({ data: "materiel/data" }),
    ...mapMultiRowFields("materiel", ["fournisseurs"]),
    ...mapMultiRowFields("materiel", ["evaluations"])
  }
};
</script>
<style lang="css"></style>
